import React from "react";
import {
    Spin,
    Card,
    Form,
    Row,
    Col,
    Input,
    Button,
    message,
    Popconfirm,
    DatePicker,
} from "antd";
import moment from "moment";

import { moaApi } from "../../../../../../api";
import NumberInput from "../../../../../crm/components/number-input";

const {
    reqArriveAdd,
    reqArriveDel,
    reqArriveEdit,
    reqArriveDetail
} = moaApi;

class ArriveAdd extends React.Component {
    state = {
        loading: true,
        detail: {},
    };
    cid = this.props.match.params.cid;
    id = this.props.match.params.id;

    validate = async (values) => {
        values.arrived_time = new Date(values.arrived_time._d);
        values.fund_id = this.cid;
        let response;
        if (!this.id) {
            for (let i in values) {
                if (!values[i]) {
                    delete values[i];
                }
            }
        }
        if (this.id) {
            values.id = this.id;
            response = await reqArriveEdit(values);
            if (response && response.data) {
                message.success('修改成功');
                this.props.history.goBack();
            }
        } else {
            response = await reqArriveAdd(values);
            if (response && response.data) {
                message.success('添加成功');
            }
        }
    };

    delArrive = async () => {
        const response = await reqArriveDel({
            id: this.id
        });
        if (response && response.data) {
            message.success('删除成功');
            this.props.history.replace(`/moa/capital/detail/${this.state.detail.fund.id}`);
        }
    };

    getArriveDetail = async (params = {}) => {
        const response = await reqArriveDetail(params);
        if (response && response.data) {
            this.setState({
                detail: response.data,
                loading: false
            });
        }
    };

    componentDidMount() {
        if (this.id) {
            // 获取详情
            this.getArriveDetail({
                id: this.id
            });
        }
    }

    render() {
        const { detail } = this.state;

        return this.id && this.state.loading ? (
            <div className="loading-container">
                <Spin size="large" />
            </div>
        ) : (
            <Form onFinish={this.validate}>
                <Button
                    type="link"
                    icon="left"
                    onClick={() => {
                        this.props.history.goBack();
                    }}
                >返回</Button>

                <Card
                    title={
                        this.id ? "修改到账资金信息" : "添加到账资金"
                    }
                    style={{
                        marginBottom: 24,
                    }}
                    bordered={false}
                    extra={
                        this.id ? (
                            <Popconfirm
                                title="确定删除该到账资金信息吗?"
                                onConfirm={this.delArrive}
                                okText="确定"
                                cancelText="取消"
                            >
                                <Button>删除</Button>
                            </Popconfirm>
                        ) : null
                    }
                >
                    <Card
                        title="到账资金基本信息"
                        bordered={false}
                        type="inner"
                    >
                        <Row gutter={{ sm: 0, md: 16, lg: 24 }}>
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                <Form.Item
                                    label="到账金额"
                                    name="amount"
                                    initialValue={detail.amount || 0}
                                    rules={[
                                        {
                                            required: true,
                                            message: '请输入到账金额',
                                        },
                                    ]}
                                >
                                    <NumberInput
                                        addonAfter="元"
                                        placeholder="请输入到账金额"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                <Form.Item
                                    label="到账时间"
                                    name="arrived_time"
                                    initialValue={detail.arrived_time ? moment(detail.arrived_time) : null}
                                    rules={[
                                        {
                                            required: true,
                                            message: '请选择到账时间',
                                        },
                                    ]}
                                >
                                    <DatePicker style={{ width: '100%' }} placeholder="请选择到账时间" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                <Form.Item
                                    label="付款单位"
                                    name="payer"
                                    initialValue={detail.payer || ''}
                                    rules={[
                                        {
                                            required: true,
                                            message: '请输入付款单位',
                                        },
                                    ]}
                                >
                                    <Input placeholder="请输入付款单位" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </Card>

                <div className="submit-footer">
                    <Button type="primary" htmlType="submit">
                        {
                            this.id ? '保存' : '提交'
                        }
                    </Button>
                </div>
            </Form>
        );
    }
}

export default ArriveAdd;